import React from 'react';
import { motion } from 'framer-motion';
import { GlowingButton } from '../ui/GlowingButton';
import { CheckCircle, Clock, Zap } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center pt-28 pb-24 overflow-hidden bg-[#050505]" data-id="element-74">
      
      {/* Background Effects (Improved) */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[500px] bg-cyan-500/20 blur-[150px] rounded-full opacity-40 pointer-events-none" data-id="element-75" />
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay pointer-events-none" data-id="element-76" />

      <div className="container mx-auto px-4 relative z-10 grid lg:grid-cols-2 gap-12 items-center" data-id="element-77">
        
        {/* TEXT CONTENT (LEFT) */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="text-center lg:text-left relative z-20" data-id="element-78">
          {/* Badge Superior */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-8 backdrop-blur-sm animate-pulse" data-id="element-79">
            <span className="w-2 h-2 rounded-full bg-green-500 shadow-[0_0_10px_#22c55e]" data-id="element-80"></span>
            <span className="text-sm font-medium text-cyan-300 tracking-wide" data-id="element-81">NUEVO SISTEMA 2026</span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black tracking-tight mb-6 leading-[1.1]" data-id="element-82">
            <span className="block text-white drop-shadow-lg" data-id="element-83">
              NO TRABAJES MÁS.
            </span>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-500 drop-shadow-[0_0_25px_rgba(6,182,212,0.5)]" data-id="element-84">
               TRABAJA INTELIGENTE.
            </span>
          </h1>

          <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-xl mx-auto lg:mx-0 leading-relaxed font-light" data-id="element-85">
            Deja de perder horas en tareas repetitivas. Descarga el <span className="text-white font-bold" data-id="element-86">"Cerebro Digital"</span> que automatiza tus correos, informes y proyectos por ti.
          </p>

          <div className="flex flex-col items-center lg:items-start gap-6" data-id="element-87">
            
            {/* Price Block */}
            <div className="flex items-center gap-6 bg-white/5 p-4 rounded-2xl border border-white/5 backdrop-blur-md" data-id="element-88">
              <div className="text-left" data-id="element-89">
                <span className="block text-sm text-gray-500 line-through font-medium" data-id="element-90">Precio Regular $102</span>
                <span className="block text-4xl font-bold text-white tracking-tight" data-id="element-91">$19.99</span>
              </div>
              <div className="h-10 w-px bg-white/10" data-id="element-92"></div>
              <div className="text-left" data-id="element-93">
                 <span className="flex items-center gap-1 text-green-400 text-sm font-bold bg-green-500/10 px-2 py-1 rounded" data-id="element-94">
                    <CheckCircle className="w-3 h-3" data-id="element-95" /> 80% OFF
                 </span>
                 <span className="block text-xs text-gray-400 mt-1" data-id="element-96">Oferta Lanzamiento</span>
              </div>
            </div>

            {/* CTA Button */}
            <GlowingButton size="xl" className="w-full md:w-auto min-w-[280px] shadow-[0_0_50px_rgba(6,182,212,0.4)] hover:shadow-[0_0_70px_rgba(6,182,212,0.6)] transition-shadow duration-500" data-id="element-97">
              DESCARGAR PACK COMPLETO
            </GlowingButton>

            {/* Trust Bar (Logos Text) */}
            <div className="mt-4 flex flex-wrap justify-center lg:justify-start gap-4 text-sm text-gray-500 items-center opacity-80" data-id="element-98">
               <span data-id="element-99">Compatible con:</span>
               <div className="flex gap-4 grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-500" data-id="element-100">
                  <span className="font-bold text-white" data-id="element-101">ChatGPT</span>
                  <span className="font-bold text-white" data-id="element-102">Claude</span>
                  <span className="font-bold text-white" data-id="element-103">Gemini</span>
                  <span className="font-bold text-white" data-id="element-104">Midjourney</span>
               </div>
            </div>
          </div>
        </motion.div>

        {/* VISUAL CONTENT (RIGHT) */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative mt-12 lg:mt-0" data-id="element-105">
          <div className="relative z-10 animate-float" data-id="element-106">
            {/* TU IMAGEN PRINCIPAL */}
            <img src="https://cdn.magicpatterns.com/uploads/6yTWKtW1aUbE4nKgriPqy7/Pack_completo.jpg" alt="Masterkit IA Bundle" className="w-full h-auto rounded-2xl shadow-2xl border border-white/10 relative z-20" data-id="element-107" />
            
            {/* Floating Cards (Elementos flotantes decorativos) */}
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut"
          }} className="absolute -top-6 -right-6 z-30 bg-[#0f172a] p-3 rounded-xl border border-cyan-500/30 shadow-lg flex items-center gap-3" data-id="element-108">
               <div className="bg-cyan-500/20 p-2 rounded-lg" data-id="element-109">
                  <Clock className="w-5 h-5 text-cyan-400" data-id="element-110" />
               </div>
               <div data-id="element-111">
                  <p className="text-xs text-gray-400" data-id="element-112">Ahorro estimado</p>
                  <p className="text-sm font-bold text-white" data-id="element-113">10h / Semana</p>
               </div>
            </motion.div>

            <motion.div animate={{
            y: [0, 10, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 1
          }} className="absolute -bottom-8 -left-4 z-30 bg-[#0f172a] p-3 rounded-xl border border-purple-500/30 shadow-lg flex items-center gap-3" data-id="element-114">
               <div className="bg-purple-500/20 p-2 rounded-lg" data-id="element-115">
                  <Zap className="w-5 h-5 text-purple-400" data-id="element-116" />
               </div>
               <div data-id="element-117">
                  <p className="text-xs text-gray-400" data-id="element-118">Productividad</p>
                  <p className="text-sm font-bold text-white" data-id="element-119">x10 Velocidad</p>
               </div>
            </motion.div>

            {/* Glow effect behind image */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-tr from-cyan-500/30 to-purple-500/30 blur-[80px] -z-10 rounded-full opacity-60" data-id="element-120" />
          </div>
        </motion.div>

      </div>
    </section>;
}